import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { PdfJob, PdfJobStatus } from 'src/app/models/pdf-job.interface';

/**
 * Component for a badge to show the number of unseen downloads.
 */
@Component({
    selector: 'app-download-badge',
    templateUrl: './download-badge.component.html',
    styleUrls: ['./download-badge.component.scss'],
    standalone: false,
})
export class DownloadBadgeComponent {
    private _pdfJobs: PdfJob[] = [];
    get pdfJobs(): PdfJob[] {
        return this._pdfJobs;
    }
    /**
     * The pdf jobs to show the badge for.
     */
    @Input() set pdfJobs(value: PdfJob[]) {
        this._pdfJobs = value;
        this.setBadge();
    }

    /**
     * Whether the pdf menu is has been seen by the user.
     */
    @Input() pdfMenuSeen = true;

    notDownloaded = 0;
    isProcessing = false;

    private readonly destroy = new Subject<void>();

    setBadge(): void {
        this.isProcessing = !!this.pdfJobs.find((j) => j.status === PdfJobStatus.PROCESSING);

        this.notDownloaded = this.pdfJobs.filter((j) => !j.downloaded).length;
    }
}
